export const stepsInSameTeleportGroup = (matterPathStep1, matterPathStep2, teleportGroups) => {
  return teleportGroups.some((group) => {
    const groupSweeps = group.pointNodes.map((point) => point.sweep);
    return groupSweeps.includes(matterPathStep1.data.id) && groupSweeps.includes(matterPathStep2.data.id);
  });
};
